export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    innerVisible: {
      get({ visible }) {
        return visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
};
